import script from "./AboutTimeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutTimeSection.vue?vue&type=script&setup=true&lang=js"

import "./AboutTimeSection.vue?vue&type=style&index=0&id=6807909e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6807909e"]])

export default __exports__